import React from 'react'
import PollDetailView from './PollDetailView'
import { Poll } from 'src/api/types/polls'

type PollPlayViewProps = {
  isPollDetailView: boolean
  pollId: number | undefined
  answerFocus?: boolean
  pollLoading?: boolean
  userId?: number
  activePollId?: number
  onPollDeleted: (pollId: number) => void
  onPlayPoll: (poll: Poll) => void
  onPollBack: () => void
  onBackToDetail?: () => void
  pollBackLabel?: string
  onNewPoll: () => void
  topRightLabel?: string
  onOpenHowToPlay: () => void
  sounds: {
    click: () => void
    submit: () => void
    drag: () => void
    celebrate: () => void
  }
}

const PollPlayView: React.FC<PollPlayViewProps> = ({
  isPollDetailView,
  pollId,
  answerFocus,
  pollLoading,
  userId,
  activePollId,
  onPollDeleted,
  onPlayPoll,
  onPollBack,
  onBackToDetail,
  pollBackLabel,
  onNewPoll,
  topRightLabel,
  onOpenHowToPlay,
  sounds,
}) => {
  if (!isPollDetailView && !pollLoading) return null

  return (
    <PollDetailView
      pollId={pollId}
      answerFocus={answerFocus}
      pollLoading={pollLoading}
      userId={userId}
      activePollId={activePollId}
      onPollDeleted={onPollDeleted}
      onPlayPoll={onPlayPoll}
      onPollBack={onPollBack}
      onBackToDetail={onBackToDetail}
      pollBackLabel={pollBackLabel}
      onNewPoll={onNewPoll}
      topRightLabel={topRightLabel}
      onOpenHowToPlay={onOpenHowToPlay}
      sounds={sounds}
    />
  )
}

export default PollPlayView
